import { DISPLAY_FORMATS, format, PARSE_FORMATS } from 'helper/dateTime';
import i18n from 'helper/i18n';
import { MeasurementDiagramPeriodType, MeasurementDiagramTypeType } from 'store/dashboard/dashboard';
import { DateType } from 'types/Date';
import { MonthType } from 'types/Month';

export type InputTrackingType = {
	date: null | DateType;
	month: null | MonthType;
	value: null | number;
};
export type InputDiagramType = {
	type: MeasurementDiagramTypeType;
	period: MeasurementDiagramPeriodType;
	scale: {
		upperBound: number;
		lowerBound: number;
		desiredWeight: null | number;
	};
	trackings: Array<InputTrackingType>;
};
export type InputDiagramsType = Array<InputDiagramType>;

export type ColumnType = {
	label: string;
	value: null | number;
};
export type DiagramType = {
	max: number;
	mid: null | number;
	min: number;
	columns?: Array<ColumnType>;
};
export type DiagramsType = {
	[key: string]: DiagramType;
};

export const fallbackDiagram: DiagramType = {
	max: 100,
	mid: null,
	min: 0,
	columns: [],
};

export function measurementDiagramsConverter(inputDiagrams: InputDiagramsType): DiagramsType {
	const out = {};

	if (!inputDiagrams || !Array.isArray(inputDiagrams)) {
		return {
			A: fallbackDiagram,
			M1: fallbackDiagram,
		};
	}

	(inputDiagrams || []).forEach(({ period, scale, trackings }) => {
		out[period] = {
			max: scale.upperBound,
			mid: scale.desiredWeight,
			min: scale.lowerBound,
			columns: trackings.map(({ date, value, month }) => {
				if (date) {
					return {
						label: format(date.date, DISPLAY_FORMATS.SHORT_DATE, PARSE_FORMATS.DATE),
						value,
					};
				}
				if (month === null) {
					return {
						label: i18n(`react.impulsCoach.monthShort.UNDEFINED`),
						value,
					};
				}
				return {
					label: i18n(`react.impulsCoach.monthShort.${month}`),
					value,
				};
			}),
		};
	});

	return out;
}

export default measurementDiagramsConverter;
